import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'iban',
})
export class IbanPipe implements PipeTransform {
  transform(value: string): string {
    if(!value) return '';
    value = value.replace(/(.{4})/g, '$1 ');
    value = value.slice(0, 2) + ' ' + value.slice(2);
    return value;
  }
}
